import Direction from '@shared/types/enums/direction';
import Screen from '@screen';
import styled from 'styled-components';
import { TRANSITION } from '@shared/types/constants/animations';

const ListAnimationContainer = styled.div<{
  direction?: Direction;
  duration: number;
  index: number;
  offset: number;
}>`
  display: flex;
  flex-direction: ${(props) =>
    props.direction === Direction.HORIZONTAL ? 'row' : 'column'};
  transform: translate(
    ${(props) => {
      const displacementX =
        props.direction === Direction.HORIZONTAL
          ? -props.offset * props.index * Screen.widthRatio
          : 0;
      const displacementY =
        props.direction === Direction.VERTICAL
          ? -props.offset * props.index * Screen.widthRatio
          : 0;
      return `${displacementX}px,${displacementY}px`;
    }}
  );
  transition: ${(props) => TRANSITION.LIST_ANIMATION(props.duration)};
`;

export default ListAnimationContainer;
